import type { UserId } from '@hotjar/user';
import { daysFromNow } from '@hotjar/webapp/lib/time';
import type { Account } from './model';
import type { OwnedAccountDto, OwnedAccount } from './owned-account';
import type { SiteAccount } from './site-account';

export function mockAccountDto(overrides: Partial<OwnedAccountDto> = {}): OwnedAccountDto {
  return {
    address: null,
    became_a_customer: 1618387097,
    billing_cycle: 'yearly_recurring',
    billing_version: 2,
    card_expiration_date: 1838073600,
    company: 'Test Company',
    created: 1618365278,
    currency: 'eur',
    features: ['poll.poll_response_filters'],
    has_paid_plan: true,
    has_payment_details: true,
    highest_plan: 'business',
    id: 1,
    is_customer: true,
    location: 'EU,MT',
    lock: false,
    next_billing_date: 1649894400,
    payment_method_type: 'credit_card',
    percentage_discount: 0,
    pricing_table_id: '3',
    recurring_payment_failed: false,
    registration_campaign: null,
    trial_state: null,
    type: 'agency',
    unpaid_invoice: null,
    vat_number: null,
    ...overrides,
  };
}

/**
 * Returns whether or not `userId` is an owner of `account`, by looking at `account.adminIds`
 * which is an array of account owner user IDs. Even though the field is called `adminIds`,
 * it should not be confused with the organization admin access level, as these two have no
 * correlation.
 */
export function isAccountOwner(
  userId?: UserId | null,
  account?: Pick<Account | SiteAccount, 'adminIds'> | undefined | null,
): boolean {
  if (!userId || !account?.adminIds?.length) {
    return false;
  }

  return account.adminIds.includes(userId);
}

export const isAccountExpired = (ownedAccount: OwnedAccount | undefined): boolean => {
  return !!(ownedAccount?.isCustomer &&
  ownedAccount?.hasPaidPlan &&
  !ownedAccount?.hasPaymentDetails &&
  ownedAccount.nextBillingDate
    ? daysFromNow(ownedAccount.nextBillingDate) <= 0
    : false);
};
